import { useState } from 'react'
import { List } from '@mui/material'

import { MobileBottomLayout, PaginationButtons } from 'src/components'
import { UpdateTranslationModal } from '../update-translation-form'
import { TranslationItem } from './transaction-item.component'
import { ITranslationWithDefault } from 'src/types'

interface IProps {
  items: ITranslationWithDefault[]
  languageCode: string
}

const TranslationsGrid = ({ items, languageCode }: IProps) => {
  const [formValues, setFormValues] = useState<ITranslationWithDefault | null>(null)

  const handleOpen = (item: ITranslationWithDefault) => () => {
    setFormValues(item)
  }

  const handleClose = () => {
    setFormValues(null)
  }

  return (
    <>
      <List sx={{ width: '100%' }}>
        {items?.map((item) => (
          <TranslationItem handleUpdate={handleOpen(item)} item={item} key={item.id} />
        ))}
      </List>
      <UpdateTranslationModal
        lng={languageCode}
        handleClose={handleClose}
        open={!!formValues}
        initialValues={formValues}
      />

      <MobileBottomLayout>
        <PaginationButtons buttonsOnly />
      </MobileBottomLayout>
    </>
  )
}

export { TranslationsGrid }
